export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type Agent = DomesticAgentMongooseClass | OverseasAgentMongooseClass;

export type BenefitCondition = {
  __typename?: 'BenefitCondition';
  benefitDesc: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  icon: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  useCond: Scalars['String']['output'];
};

export enum BooKingProductType {
  Domestic = 'DOMESTIC',
  Overseas = 'OVERSEAS',
}

export type Booking = DomesticBooking | OverseasBooking;

export type BookingAgreementModelClass = {
  __typename?: 'BookingAgreementModelClass';
  id: Scalars['ID']['output'];
  nidNo: Scalars['String']['output'];
  ts?: Maybe<Scalars['String']['output']>;
};

export enum BookingDeviceType {
  Mobile = 'MOBILE',
  Pc = 'PC',
}

export enum BookingPayStatus {
  Cancel = 'CANCEL',
  Done = 'DONE',
  Repay = 'REPAY',
}

export enum BookingProductTravelProgress {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

export type BookingPromotion = {
  __typename?: 'BookingPromotion';
  /** 프로모션 카테고리, 기본적립: basic / 카드사적립: card */
  category?: Maybe<BookingPromotionCategory>;
  /** 적립률 */
  nPayCond?: Maybe<Scalars['Int']['output']>;
  /** 네이버페이 적립 예정 일자 */
  nPayDate: Scalars['DateTime']['output'];
  /** 네이버페이 적립 예정 금액 */
  nPayFare: Scalars['Int']['output'];
  /** 프로모션 ID */
  promotionId: Scalars['String']['output'];
};

export enum BookingPromotionCategory {
  Basic = 'BASIC',
  Card = 'CARD',
}

export enum BookingStatus {
  Rsvcf = 'RSVCF',
  Rsvcn = 'RSVCN',
  Rsvrc = 'RSVRC',
  Rsvwa = 'RSVWA',
}

export type BookingStatusLabel = {
  __typename?: 'BookingStatusLabel';
  /** 예약 상태 라벨 색상 */
  color: Scalars['String']['output'];
  /** 예약 상태 라벨 노출 텍스트 */
  name: Scalars['String']['output'];
};

export type BookingUnionConnection = {
  __typename?: 'BookingUnionConnection';
  edges?: Maybe<Array<BookingUnionEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BookingUnionEdge = {
  __typename?: 'BookingUnionEdge';
  node: Booking;
};

export type Budget = {
  __typename?: 'Budget';
  amount: Scalars['Float']['output'];
  budgetType?: Maybe<Scalars['String']['output']>;
  flexibility: Scalars['String']['output'];
};

export type BudgetInput = {
  amount: Scalars['Float']['input'];
  budgetType?: InputMaybe<Scalars['String']['input']>;
  flexibility: Scalars['String']['input'];
};

export type Car = {
  __typename?: 'Car';
  include: Scalars['Boolean']['output'];
  rentCarCode?: Maybe<Scalars['String']['output']>;
  rentCarName?: Maybe<Scalars['String']['output']>;
};

export type CodeName = {
  __typename?: 'CodeName';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CodeNameInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CodeType = {
  __typename?: 'CodeType';
  code: Scalars['String']['output'];
  isDirectInput: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CodesNameInput = {
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CodesOptionalName = {
  __typename?: 'CodesOptionalName';
  codes?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  channel: Scalars['String']['input'];
  nationNo: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  preferredHourRange: Array<HourRange>;
};

export type ContactWithoutHourRange = {
  channel: Scalars['String']['input'];
  nationNo: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
};

export type Coupon = {
  __typename?: 'Coupon';
  couponTitle: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  maxDiscountPrice: Scalars['Int']['output'];
  minPrice: Scalars['Int']['output'];
  savedPrice: Scalars['Int']['output'];
};

export type CouponResponse = {
  __typename?: 'CouponResponse';
  discountCouponByUserGrade: Coupon;
  /** 등급별 사용 가능한 쿠폰 리스트 */
  discountCoupons?: Maybe<Array<Coupon>>;
};

export type Cruise = {
  __typename?: 'Cruise';
  details?: Maybe<Array<CruiseDetail>>;
};

export type CruiseDetail = {
  __typename?: 'CruiseDetail';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomAgent = {
  __typename?: 'CustomAgent';
  agtCode: Scalars['String']['output'];
  agtLogoUrl: Scalars['String']['output'];
  landingUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tel: Scalars['String']['output'];
};

export type CustomContact = {
  __typename?: 'CustomContact';
  channel: Scalars['String']['output'];
  preferredHourRange: Array<CustomHourRange>;
};

export type CustomEstimate = {
  __typename?: 'CustomEstimate';
  activeReceivedAlert: Scalars['Boolean']['output'];
  additionalRequirementCheckList?: Maybe<Array<CodeName>>;
  additionalRequirements?: Maybe<Scalars['String']['output']>;
  budget?: Maybe<Budget>;
  contact: CustomContact;
  createdAt: Scalars['DateTime']['output'];
  createdAtStr: Scalars['String']['output'];
  customizeAgent?: Maybe<CustomAgent>;
  customizeAgtCode: Scalars['String']['output'];
  customizeProduct?: Maybe<CustomProduct>;
  customizeProductFamily?: Maybe<CustomProductFamily>;
  customizeProductFamilyId: Scalars['String']['output'];
  customizeProductId: Scalars['String']['output'];
  dayDiff?: Maybe<Scalars['Float']['output']>;
  destinations?: Maybe<Array<CodesOptionalName>>;
  estimateAgent: CustomAgent;
  estimateAgtCode: Scalars['String']['output'];
  estimateDetailUrl?: Maybe<Scalars['String']['output']>;
  estimateDownloadUrl?: Maybe<Scalars['String']['output']>;
  estimateGroupId: Scalars['String']['output'];
  estimateId: Scalars['String']['output'];
  estimateProductFamilyId: Scalars['String']['output'];
  estimateProductId: Scalars['String']['output'];
  estimateRequestAgtCode: Scalars['String']['output'];
  estimateStatus: EstimateStatus;
  estimateStatusInfo?: Maybe<Scalars['String']['output']>;
  estimateType: CustomEstimateType;
  flight?: Maybe<CustomFlight>;
  groupType: CodeName;
  hotel?: Maybe<CustomHotel>;
  id: Scalars['String']['output'];
  inquireUrl?: Maybe<Scalars['String']['output']>;
  mealOrShoppings?: Maybe<Array<CodeName>>;
  personalCount?: Maybe<PersonalCount>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  requestAgent: CustomAgent;
  thumbnailUrl: Scalars['String']['output'];
  tourSchedule?: Maybe<TourSchedule>;
  visitAreaNames?: Maybe<Scalars['String']['output']>;
  visitCountries?: Maybe<Array<CodeName>>;
};

export type CustomEstimateGroupByStatus = {
  __typename?: 'CustomEstimateGroupByStatus';
  additionalRequirementCheckList?: Maybe<Array<CodeName>>;
  budget?: Maybe<Budget>;
  contact: CustomContact;
  destinations?: Maybe<Array<CodesOptionalName>>;
  estimateAgtCode: Scalars['String']['output'];
  estimateGroupId: Scalars['String']['output'];
  estimateProductFamilyId: Scalars['String']['output'];
  estimateProductId: Scalars['String']['output'];
  estimateStatus: EstimateStatus;
  estimates: Array<CustomEstimate>;
  flight?: Maybe<CustomFlight>;
  groupType: CodeName;
  hotel?: Maybe<CustomHotel>;
  id: Scalars['String']['output'];
  mealOrShoppings?: Maybe<Array<CodeName>>;
  personalCount?: Maybe<PersonalCount>;
  tourSchedule?: Maybe<TourSchedule>;
  visitCountries?: Maybe<Array<CodeName>>;
};

export type CustomEstimateGroupsResponse = {
  __typename?: 'CustomEstimateGroupsResponse';
  groupEstimates: Array<CustomEstimateGroupByStatus>;
  totalCount: Scalars['Float']['output'];
};

export enum CustomEstimateType {
  Advisor = 'ADVISOR',
  Self = 'SELF',
}

export type CustomFlight = {
  __typename?: 'CustomFlight';
  airlineType: Scalars['String']['output'];
  preferredAirlines?: Maybe<Array<Scalars['String']['output']>>;
};

export type CustomHotel = {
  __typename?: 'CustomHotel';
  minStarRate?: Maybe<Scalars['Int']['output']>;
  preferredHotels?: Maybe<Array<Scalars['String']['output']>>;
};

export type CustomHourRange = {
  __typename?: 'CustomHourRange';
  from: Scalars['Float']['output'];
  to: Scalars['Float']['output'];
};

export type CustomOption = {
  __typename?: 'CustomOption';
  additionalRequirementCheckList: Array<CodeType>;
  groupDescription: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  groupType: Scalars['String']['output'];
  mealOrShoppings: Array<CodeType>;
  specialNotes: Array<CodeType>;
};

export type CustomProduct = {
  __typename?: 'CustomProduct';
  beginDate: Scalars['String']['output'];
  beginDateStr: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  endDateStr?: Maybe<Scalars['String']['output']>;
  prices: ProductPrice;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedAtStr: Scalars['String']['output'];
};

export type CustomProductFamily = {
  __typename?: 'CustomProductFamily';
  airline?: Maybe<CodeName>;
  dayPeriod: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  nightPeriod: Scalars['Int']['output'];
};

export type CustomRecommend = {
  __typename?: 'CustomRecommend';
  cityCodes: Array<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  minOrder: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  recommends?: Maybe<Array<RecommendType>>;
};

export enum CustomTravelType {
  Active = 'ACTIVE',
  CustomOnly = 'CUSTOM_ONLY',
}

export type DiscountCondition = {
  __typename?: 'DiscountCondition';
  discountPrice?: Maybe<Scalars['Int']['output']>;
  discountRate: Scalars['Int']['output'];
  grade: Scalars['Int']['output'];
  maxDiscountPrice: Scalars['Int']['output'];
  maxPrice: Scalars['Int']['output'];
  minPrice: Scalars['Int']['output'];
};

export type DisplayedSearchHistoryModelClass = {
  __typename?: 'DisplayedSearchHistoryModelClass';
  agent: Agent;
  agentId: Scalars['String']['output'];
  bookingUrl?: Maybe<Scalars['String']['output']>;
  daysSinceLastViewed: Scalars['Float']['output'];
  isDomestic: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  snapshotPrice: Scalars['Float']['output'];
  timeString: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
};

export type DisplayedZzimModelClass = {
  __typename?: 'DisplayedZzimModelClass';
  agent: Agent;
  agtCode: Scalars['String']['output'];
  bookingUrl?: Maybe<Scalars['String']['output']>;
  daysSinceZzimDay: Scalars['Float']['output'];
  expired: Scalars['Boolean']['output'];
  isDomestic: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  snapshotPrice: Scalars['Float']['output'];
  updateDate: Scalars['DateTime']['output'];
};

export type DomesticAgentMongooseClass = {
  __typename?: 'DomesticAgentMongooseClass';
  _id: Scalars['String']['output'];
  addr?: Maybe<Scalars['String']['output']>;
  agentId: Scalars['String']['output'];
  agtCode: Scalars['String']['output'];
  agtLogoUrl: Scalars['String']['output'];
  bookingCallDesc?: Maybe<Scalars['String']['output']>;
  bookingCallMethod?: Maybe<Scalars['String']['output']>;
  bookingTarget?: Maybe<Scalars['String']['output']>;
  /** 해외여행에서만 사용하는 필드 */
  customActive?: Maybe<Scalars['String']['output']>;
  /** 해외여행에서만 사용하는 필드 */
  customGroupTypes?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inquiryAvailableTime?: Maybe<Scalars['String']['output']>;
  inquiryInfo?: Maybe<Scalars['String']['output']>;
  inquiryLunchTime?: Maybe<Scalars['String']['output']>;
  inquiryUnavailableTime?: Maybe<Scalars['String']['output']>;
  isCallCenterActive?: Maybe<Scalars['Boolean']['output']>;
  isSoleTrader?: Maybe<Scalars['Boolean']['output']>;
  kakaoPlusFriendId?: Maybe<Scalars['String']['output']>;
  landingUrl: Scalars['String']['output'];
  mailOrderSalesNum?: Maybe<Scalars['String']['output']>;
  mainCallDesc?: Maybe<Array<Scalars['String']['output']>>;
  mainCallFailDesc?: Maybe<Scalars['String']['output']>;
  mainCallNum?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  preBookingTarget?: Maybe<Scalars['String']['output']>;
  regionCallFailDesc?: Maybe<Scalars['String']['output']>;
  regionCallNums?: Maybe<Array<DomesticregionCallNums>>;
  representative?: Maybe<Scalars['String']['output']>;
  representativeBirth?: Maybe<Scalars['String']['output']>;
  supportNaverPlus?: Maybe<Scalars['Boolean']['output']>;
  talkTalkActive?: Maybe<Scalars['Boolean']['output']>;
  talkTalkId?: Maybe<Scalars['String']['output']>;
  taxNum?: Maybe<Scalars['String']['output']>;
  tel: Scalars['String']['output'];
  tourBusinessNum?: Maybe<Scalars['String']['output']>;
};

export type DomesticBooking = {
  __typename?: 'DomesticBooking';
  agent: DomesticAgentMongooseClass;
  /** 여행사 코드 */
  agtCode: Scalars['String']['output'];
  /** 예약일 */
  bookingDate: Scalars['DateTime']['output'];
  /** 예약번호, ttp originBookingId 기준으로 전송 */
  bookingId: Scalars['String']['output'];
  /** 예약상태 */
  bookingStatus: BookingStatus;
  /** 애플리케이션 등록 시 발급받은 Client ID 값 */
  clientId: Scalars['String']['output'];
  /** 애플리케이션 등록 시 받은 Client secret 값 */
  clientSecret: Scalars['String']['output'];
  /** 별도견적 여부 */
  customRate?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** PC: P / MOBILE: M */
  deviceType: BookingDeviceType;
  /** 톡톡알림 미전송 여부 */
  disableAlarm?: Maybe<Scalars['Boolean']['output']>;
  /** 예약 세부 내역 */
  fareInfo: DomesticBookingFareInfo;
  grade?: Maybe<Scalars['Int']['output']>;
  gradeUpgradedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isNaverPlus?: Maybe<Scalars['Boolean']['output']>;
  membershipDate?: Maybe<Scalars['String']['output']>;
  /** 유저 nidno */
  nidNo: Scalars['String']['output'];
  /** 네이버 로그인 Key */
  nloginKey: Scalars['String']['output'];
  originBookingId?: Maybe<Scalars['String']['output']>;
  /** 결제일 */
  payDate: Scalars['DateTime']['output'];
  /** 결제상태 */
  payStatus: BookingPayStatus;
  product?: Maybe<DomesticProductModelClass>;
  /** 모상품 ID */
  productFamilyId: Scalars['String']['output'];
  /** 자상품 ID */
  productId: Scalars['String']['output'];
  /** 자상품 명 */
  productName?: Maybe<Scalars['String']['output']>;
  /** 상품 상태 */
  productStatus: ProductStatus;
  /** Overseas, Domestic 여부 */
  productType?: Maybe<BooKingProductType>;
  savingPaypoint?: Maybe<SavingPaypointModelClass>;
  statusLabel?: Maybe<BookingStatusLabel>;
  /** 톡톡 노출여부 */
  talkTalkActive?: Maybe<Scalars['Boolean']['output']>;
  /** 톡톡 URL */
  talkTalkUrl?: Maybe<Scalars['String']['output']>;
  travelClubPaypoint?: Maybe<TravelClubPaypointModelClass>;
  travelProgress?: Maybe<BookingProductTravelProgress>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type DomesticBookingFareInfo = {
  __typename?: 'DomesticBookingFareInfo';
  /** 성인 수 */
  adult: Scalars['Int']['output'];
  /** 소아 수 */
  child: Scalars['Int']['output'];
  /** 유아 수 */
  infant: Scalars['Int']['output'];
  nPayDate?: Maybe<Scalars['Int']['output']>;
  nPayFare?: Maybe<Scalars['DateTime']['output']>;
  /** 프로모션 정보 */
  promotion?: Maybe<Array<BookingPromotion>>;
  /** 총 요금 */
  totalFare: Scalars['Int']['output'];
  /** 요금 대상 */
  totalPerson: Scalars['Int']['output'];
};

export type DomesticOptionalPlace = {
  __typename?: 'DomesticOptionalPlace';
  placeId?: Maybe<Scalars['Int']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
};

export type DomesticPlace = {
  __typename?: 'DomesticPlace';
  dongCodeName: DongCodeName;
  placeId: Scalars['Int']['output'];
  placeName: Scalars['String']['output'];
};

export type DomesticProductFamilyModelClass = {
  __typename?: 'DomesticProductFamilyModelClass';
  /** 여행사코드 */
  agtCode: Scalars['String']['output'];
  /** 출발지 간단설명(최대100자) */
  beginPlaceDesc: Scalars['String']['output'];
  /** 출발지 정보(최대 5개) */
  beginPlaces: Array<DomesticPlace>;
  /** 취소 및 환불규정(5자~1500자), 개행가능 */
  cancelRefundRules: Array<Scalars['String']['output']>;
  /** 별도견적 여부 */
  customRate?: Maybe<Scalars['Boolean']['output']>;
  /** 여행기간 n일 */
  dayPeriod: Scalars['Int']['output'];
  departureCityName: Scalars['String']['output'];
  /** 상품 불포함내역(5자~400자), 개행가능 */
  excludeOptions: Array<Scalars['String']['output']>;
  firstImage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** 여행이미지 */
  images: Array<Scalars['String']['output']>;
  /** 상품 포함내역(5자~400자), 개행가능 */
  includeOptions: Array<Scalars['String']['output']>;
  /** 섬상품 섬 이름(필터에 활용) */
  islandNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Mobile 상품핵심이미지 주소 */
  keyImagesMo?: Maybe<Array<Scalars['String']['output']>>;
  /** PC 상품핵심이미지 주소 */
  keyImagesPc?: Maybe<Array<Scalars['String']['output']>>;
  /** 상품 특장점(5자~400자), 개행가능 */
  keyPoints: Array<Scalars['String']['output']>;
  /** 인솔자 여부 */
  leader: Scalars['Boolean']['output'];
  /** 인솔자 및 현지가이드(5자~400자), 개행가능 */
  leaderGuideDesc: Array<Scalars['String']['output']>;
  /** 지방출발상품여부 */
  localBegin: Scalars['Boolean']['output'];
  /** 현지가이드 여부 */
  localGuide: Scalars['Boolean']['output'];
  /** 포함된 식사횟수 */
  mealCount: Scalars['Int']['output'];
  /** 식사상세설명(최대200자) */
  mealDesc: Scalars['String']['output'];
  /** 모이는 장소 및 시각(5자~1500자), 개행가능 */
  meetingInfo: Array<Scalars['String']['output']>;
  /** 여행기간 n박 */
  nightPeriod: Scalars['Int']['output'];
  /** 유의사항(5자~1000자), 개행가능 */
  notices: Array<Scalars['String']['output']>;
  /** 여행장소 정보 */
  places: Array<DomesticPlace>;
  /** 준비물(5자~400자), 개행가능 */
  preparations: Array<Scalars['String']['output']>;
  /** 성인 1인 기준 가격 */
  price: Scalars['Int']['output'];
  /** 상품가격설명(5자~400자), 개행가능 */
  priceDesc: Array<Scalars['String']['output']>;
  /** MO 상품가격이미지 주소 */
  priceImagesMo?: Maybe<Array<Scalars['String']['output']>>;
  /** PC 상품가격이미지 주소 */
  priceImagesPc?: Maybe<Array<Scalars['String']['output']>>;
  /** 모상품 코드(3~50자) */
  productFamilyId: Scalars['String']['output'];
  /** 모상품 제목(최대80자) */
  productFamilyName: Scalars['String']['output'];
  schedules: Array<DomesticSchedule>;
  /** 통검 노출 우선 */
  searchActive: Scalars['Boolean']['output'];
  /** 서비스 노출 여부 */
  serviceActive: Scalars['Boolean']['output'];
  /** 여행 테마(최대5개) */
  themes: Array<Scalars['String']['output']>;
  /** 여행 상품 구분(최대4개) */
  tourTypes: Array<DomesticTourType>;
};

export type DomesticProductModelClass = {
  __typename?: 'DomesticProductModelClass';
  /** 여행사코드 */
  agtCode: Scalars['String']['output'];
  /** 출발일시, yyyy.MM.dd. hh:mm */
  beginDate: Scalars['String']['output'];
  /** 최대 예약 수(총 좌석수) */
  bookMaxSeat: Scalars['Int']['output'];
  /** 최소 출발 인원 */
  bookMinSeat: Scalars['Int']['output'];
  displayStatusName: Scalars['String']['output'];
  durationString: Scalars['String']['output'];
  /** 도착일, yyyy.MM.dd. */
  endDate?: Maybe<Scalars['String']['output']>;
  finalProductName: Scalars['String']['output'];
  finalProductStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** 오후출발상품여부 */
  pmBegin: Scalars['Boolean']['output'];
  /** 성인 1인 기준 가격 */
  price: Scalars['Int']['output'];
  productFamily?: Maybe<DomesticProductFamilyModelClass>;
  /** 모상품 코드 */
  productFamilyId: Scalars['String']['output'];
  /** 자상품 코드(3~58자) */
  productId: Scalars['String']['output'];
  /** 자상품 제목(최대80자) */
  productName: Scalars['String']['output'];
  /** 상품 상태 */
  productStatus: ProductStatus;
  /** 지원특가여부 */
  specialPrice: Scalars['Boolean']['output'];
};

export type DomesticProductModelClassProductFamilyArgs = {
  ignoreServiceActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DomesticSchedule = {
  __typename?: 'DomesticSchedule';
  /** 여행일차 */
  dayOfSchedule: Scalars['Int']['output'];
  /** 숙소정보(2자~50자) */
  hotel?: Maybe<Scalars['String']['output']>;
  /** 일정표 정보 */
  info: DomesticScheduleInfo;
  /** 식사정보 */
  meals?: Maybe<DomesticScheduleMeal>;
  /** 여행장소 정보 */
  tripPlaces: Array<DomesticOptionalPlace>;
};

export enum DomesticScheduleDetailType {
  Desc = 'DESC',
  Image = 'IMAGE',
  Title = 'TITLE',
}

export type DomesticScheduleInfo = {
  __typename?: 'DomesticScheduleInfo';
  /** 에디터방식 - 일정표 상세정보 */
  details?: Maybe<DomesticScheduleInfoDetail>;
  /** MO 일정표 이미지 주소(0장~5장) */
  imagesMo?: Maybe<Array<Scalars['String']['output']>>;
  /** PC 일정표 이미지 주소(0장~5장) */
  imagesPc?: Maybe<Array<Scalars['String']['output']>>;
  /** 일정표 입력방식 ("image" 또는 "editor") */
  type: DomesticScheduleType;
};

export type DomesticScheduleInfoDetail = {
  __typename?: 'DomesticScheduleInfoDetail';
  /** 일정표 정보 */
  content?: Maybe<Scalars['String']['output']>;
  /** 일정표 타입 ("title", "desc", "image") */
  type?: Maybe<DomesticScheduleDetailType>;
};

export type DomesticScheduleMeal = {
  __typename?: 'DomesticScheduleMeal';
  /** 조식(2자~20자) */
  breakfast?: Maybe<Scalars['String']['output']>;
  /** 석식(2자~20자) */
  dinner?: Maybe<Scalars['String']['output']>;
  /** 중식(2자~20자) */
  lunch?: Maybe<Scalars['String']['output']>;
};

export enum DomesticScheduleType {
  Editor = 'EDITOR',
  Image = 'IMAGE',
}

export enum DomesticTourType {
  Bus = 'BUS',
  Golf = 'GOLF',
  Itour = 'ITOUR',
  Join = 'JOIN',
  Ltour = 'LTOUR',
  Ticket = 'TICKET',
  Train = 'TRAIN',
}

export type DomesticregionCallNums = {
  __typename?: 'DomesticregionCallNums';
  callNum: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type DongCodeName = {
  __typename?: 'DongCodeName';
  do: Scalars['String']['output'];
  dong: Scalars['String']['output'];
  ri: Scalars['String']['output'];
  si: Scalars['String']['output'];
};

export enum EstimateStatus {
  Canceled = 'CANCELED',
  Check = 'CHECK',
  Confirmed = 'CONFIRMED',
  Quoted = 'QUOTED',
  Received = 'RECEIVED',
  Requested = 'REQUESTED',
}

export type Flight = {
  __typename?: 'Flight';
  detail: FlightDetail;
  include: Scalars['Boolean']['output'];
};

export type FlightDetail = {
  __typename?: 'FlightDetail';
  departureVia: Scalars['Float']['output'];
  returnVia: Scalars['Float']['output'];
};

export type FlightInput = {
  airlineType: Scalars['String']['input'];
  preferredAirlines?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum GroupType {
  Family = 'FAMILY',
  Friendship = 'FRIENDSHIP',
  Vacation = 'VACATION',
  Workshop = 'WORKSHOP',
  Etc = 'etc',
}

export type HistoryProduct = {
  __typename?: 'HistoryProduct';
  agentId: Scalars['String']['output'];
  isDomestic: Scalars['Boolean']['output'];
  productId: Scalars['String']['output'];
  snapshotPrice: Scalars['Float']['output'];
  timestamp: Scalars['Float']['output'];
};

export type Holiday = {
  __typename?: 'Holiday';
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type HotelInput = {
  minStarRate?: InputMaybe<Scalars['Int']['input']>;
  preferredHotels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HourRange = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type InputBookingSortOptions = {
  bookingDate?: InputMaybe<MongoSortOptions>;
  product___beginDate?: InputMaybe<MongoSortOptions>;
};

export type InputEstimateSortOptions = {
  createdDate?: InputMaybe<MongoSortOptions>;
  receivedDate?: InputMaybe<MongoSortOptions>;
};

export type InquiryCount = {
  __typename?: 'InquiryCount';
  count: Scalars['Float']['output'];
  isNew: Scalars['Boolean']['output'];
};

export type IsoCountry = {
  __typename?: 'IsoCountry';
  countryName: Scalars['String']['output'];
  countryNo: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDefaultValue: Scalars['Boolean']['output'];
};

export type Me = {
  __typename?: 'Me';
  canUseCustomTravel: Scalars['Boolean']['output'];
  config?: Maybe<Scalars['JSON']['output']>;
  /** 네이버 유저 식별자(NidNo) */
  id?: Maybe<Scalars['String']['output']>;
  isLogin: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type MinMaxPrice = {
  __typename?: 'MinMaxPrice';
  /** 출발가능한 연도-월 리스트 */
  activeMonthList?: Maybe<Array<Scalars['String']['output']>>;
  /** 최대금액 */
  maxPrice?: Maybe<Scalars['Int']['output']>;
  /** 최소금액 */
  minPrice?: Maybe<Scalars['Int']['output']>;
  /** 최소금액 출발일 */
  minPriceBeginDate?: Maybe<Scalars['String']['output']>;
  /** 최소금액 출발월 */
  minPriceBeginMonth?: Maybe<Scalars['Int']['output']>;
};

export enum MongoSortOptions {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Mutation = {
  __typename?: 'Mutation';
  accumulateSavingPaypoint: SavingPaypointModelClass;
  accumulateTravelClubPaypoint: TravelClubPaypointModelClass;
  createCustomEstimate: CustomEstimate;
  createCustomEstimatesByEstimateId: Array<CustomEstimate>;
  deleteAllInActiveBookings: Array<Booking>;
  deleteBooking: Booking;
  deleteEstimates: Scalars['Boolean']['output'];
  deleteEstimatesByStatus: Scalars['Boolean']['output'];
  deleteMySearchHistories: Scalars['Boolean']['output'];
  deleteMyZzims: Scalars['Boolean']['output'];
  saveBookingAgreement: BookingAgreementModelClass;
  sendSMS: SmsVerificationInfoGraphqlType;
  verifySms: VerifySmsGraphqlType;
};

export type MutationAccumulateSavingPaypointArgs = {
  agtCode: Scalars['String']['input'];
  bizType: TravelClubPaypointBizType;
  bookingId: Scalars['String']['input'];
};

export type MutationAccumulateTravelClubPaypointArgs = {
  agtCode: Scalars['String']['input'];
  bizType: TravelClubPaypointBizType;
  bookingId: Scalars['String']['input'];
};

export type MutationCreateCustomEstimateArgs = {
  additionalRequirementCheckList?: InputMaybe<Array<CodeNameInput>>;
  additionalRequirements?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<BudgetInput>;
  contact: Contact;
  contactTradeId: Scalars['String']['input'];
  destinations?: InputMaybe<Array<CodesNameInput>>;
  estimateAgtCode: Scalars['String']['input'];
  estimateProductFamilyId: Scalars['String']['input'];
  estimateProductId: Scalars['String']['input'];
  estimateType: Scalars['String']['input'];
  flight?: InputMaybe<FlightInput>;
  groupType: CodeNameInput;
  hotel?: InputMaybe<HotelInput>;
  mealOrShoppings?: InputMaybe<Array<CodeNameInput>>;
  personalCount?: InputMaybe<PersonalCountInput>;
  requirements: Array<CodeNameInput>;
  specialNote?: InputMaybe<CodeNameInput>;
  terms: Array<Term>;
  tourSchedule?: InputMaybe<TourScheduleInput>;
  visitCountries?: InputMaybe<Array<CodeNameInput>>;
};

export type MutationCreateCustomEstimatesByEstimateIdArgs = {
  contact: ContactWithoutHourRange;
  contactTradeId: Scalars['String']['input'];
  estimateId: Scalars['String']['input'];
  estimateRequestAgtCodes: Array<Scalars['String']['input']>;
  terms: Array<Term>;
};

export type MutationDeleteBookingArgs = {
  bookingId: Scalars['String']['input'];
  bookingProductType: BooKingProductType;
};

export type MutationDeleteEstimatesArgs = {
  estimateIds: Array<Scalars['String']['input']>;
};

export type MutationDeleteEstimatesByStatusArgs = {
  estimateStatus: Array<EstimateStatus>;
};

export type MutationDeleteMySearchHistoriesArgs = {
  productIds: Array<Scalars['String']['input']>;
};

export type MutationDeleteMyZzimsArgs = {
  productIds: Array<Scalars['String']['input']>;
};

export type MutationSendSmsArgs = {
  nationNo: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
};

export type MutationVerifySmsArgs = {
  smsVal: Scalars['String']['input'];
  tradeId: Scalars['String']['input'];
};

export type OverseasAgentMongooseClass = {
  __typename?: 'OverseasAgentMongooseClass';
  _id: Scalars['String']['output'];
  addr?: Maybe<Scalars['String']['output']>;
  agtCode: Scalars['String']['output'];
  agtLogoUrl: Scalars['String']['output'];
  bookingCallDesc?: Maybe<Scalars['String']['output']>;
  bookingCallMethod?: Maybe<Scalars['String']['output']>;
  bookingTarget?: Maybe<Scalars['String']['output']>;
  customActive?: Maybe<Scalars['Boolean']['output']>;
  customGroupTypes?: Maybe<Array<GroupType>>;
  customKakaoActive?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inquiryAvailableTime?: Maybe<Scalars['String']['output']>;
  inquiryInfo?: Maybe<Scalars['String']['output']>;
  inquiryLunchTime?: Maybe<Scalars['String']['output']>;
  inquiryUnavailableTime?: Maybe<Scalars['String']['output']>;
  isCallCenterActive?: Maybe<Scalars['Boolean']['output']>;
  isSoleTrader?: Maybe<Scalars['Boolean']['output']>;
  kakaoPlusFriendId?: Maybe<Scalars['String']['output']>;
  landingUrl: Scalars['String']['output'];
  mailOrderSalesNum?: Maybe<Scalars['String']['output']>;
  mainCallDesc?: Maybe<Array<Scalars['String']['output']>>;
  mainCallFailDesc?: Maybe<Scalars['String']['output']>;
  mainCallNum?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  preBookingTarget?: Maybe<Scalars['String']['output']>;
  regionCallFailDesc?: Maybe<Scalars['String']['output']>;
  regionCallNums?: Maybe<Array<OverseasRegionCallNums>>;
  representative?: Maybe<Scalars['String']['output']>;
  representativeBirth?: Maybe<Scalars['String']['output']>;
  supportNaverPlus?: Maybe<Scalars['Boolean']['output']>;
  talkTalkActive?: Maybe<Scalars['Boolean']['output']>;
  talkTalkId?: Maybe<Scalars['String']['output']>;
  taxNum?: Maybe<Scalars['String']['output']>;
  tel: Scalars['String']['output'];
  tourBusinessNum?: Maybe<Scalars['String']['output']>;
};

export type OverseasBooking = {
  __typename?: 'OverseasBooking';
  agent: OverseasAgentMongooseClass;
  /** 여행사 코드 */
  agtCode: Scalars['String']['output'];
  /** 잔금 결제 금액 */
  balancePayAmount?: Maybe<Scalars['Int']['output']>;
  /** 잔금 결제 링크 */
  balancePayLink?: Maybe<Scalars['String']['output']>;
  /** 예약일 */
  bookingDate: Scalars['DateTime']['output'];
  /** 예약번호, ttp originBookingId 기준으로 전송 */
  bookingId: Scalars['String']['output'];
  /** 예약상태 */
  bookingStatus: BookingStatus;
  /** 애플리케이션 등록 시 발급받은 Client ID 값 */
  clientId: Scalars['String']['output'];
  /** 애플리케이션 등록 시 받은 Client secret 값 */
  clientSecret: Scalars['String']['output'];
  /** 별도견적 여부 */
  customRate?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** PC: P / MOBILE: M */
  deviceType: BookingDeviceType;
  /** 톡톡알림 미전송 여부 */
  disableAlarm?: Maybe<Scalars['Boolean']['output']>;
  /** 예약 세부 내역 */
  fareInfo: OverseasBookingFareInfo;
  grade?: Maybe<Scalars['Int']['output']>;
  gradeUpgradedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 1:1 문의 URL */
  inquiryUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isNaverPlus?: Maybe<Scalars['Boolean']['output']>;
  membershipDate?: Maybe<Scalars['String']['output']>;
  /** 유저 nidno */
  nidNo: Scalars['String']['output'];
  /** 네이버 로그인 Key */
  nloginKey: Scalars['String']['output'];
  originBookingId?: Maybe<Scalars['String']['output']>;
  /** 결제일 */
  payDate: Scalars['DateTime']['output'];
  /** 결제상태 */
  payStatus: BookingPayStatus;
  product?: Maybe<OverseasProductMongooseClass>;
  /** 모상품 ID */
  productFamilyId: Scalars['String']['output'];
  /** 자상품 ID */
  productId: Scalars['String']['output'];
  /** 자상품 명 */
  productName?: Maybe<Scalars['String']['output']>;
  /** 상품 상태 */
  productStatus: ProductStatus;
  /** Overseas, Domestic 여부 */
  productType?: Maybe<BooKingProductType>;
  savingPaypoint?: Maybe<SavingPaypointModelClass>;
  statusLabel?: Maybe<BookingStatusLabel>;
  /** 톡톡 노출여부 */
  talkTalkActive?: Maybe<Scalars['Boolean']['output']>;
  /** 톡톡 URL */
  talkTalkUrl?: Maybe<Scalars['String']['output']>;
  travelClubPaypoint?: Maybe<TravelClubPaypointModelClass>;
  travelProgress?: Maybe<BookingProductTravelProgress>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** 바우처 URL */
  voucherUrl?: Maybe<Scalars['String']['output']>;
};

export type OverseasBookingFareInfo = {
  __typename?: 'OverseasBookingFareInfo';
  /** 성인 수 */
  adult: Scalars['Int']['output'];
  /** 소아 수 */
  child: Scalars['Int']['output'];
  /** 유아 수 */
  infant: Scalars['Int']['output'];
  /** 결제한 금액 */
  paymentAmount: Scalars['Int']['output'];
  /** 프로모션 정보 */
  promotion?: Maybe<Array<BookingPromotion>>;
  /** 남은 금액 */
  remainingAmount: Scalars['Int']['output'];
  /** 총 요금 */
  totalFare: Scalars['Int']['output'];
  /** 요금 대상 */
  totalPerson: Scalars['Int']['output'];
};

export type OverseasProductFamilyMongooseClass = {
  __typename?: 'OverseasProductFamilyMongooseClass';
  _id: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  agtCode: Scalars['String']['output'];
  beginCityName?: Maybe<Scalars['String']['output']>;
  confirmationTime?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customRate?: Maybe<Scalars['Boolean']['output']>;
  customTravelType?: Maybe<CustomTravelType>;
  dayPeriod: Scalars['Int']['output'];
  firstImage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  isTicketpass?: Maybe<Scalars['Boolean']['output']>;
  isTicketpassImmediately?: Maybe<Scalars['Boolean']['output']>;
  nightPeriod: Scalars['Int']['output'];
  productFamilyId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productStatus: Scalars['String']['output'];
  ride?: Maybe<Ride>;
  shopping?: Maybe<Shopping>;
  tips?: Maybe<Tips>;
  tourCategory: TourCategory;
  trafficAir: Flight;
  trafficCar: Car;
  trafficCruise: Cruise;
  updatedAt: Scalars['DateTime']['output'];
  visitAreas: Array<VisitAreaType>;
  visitCountryCodes: Array<Scalars['String']['output']>;
};

export type OverseasProductMongooseClass = {
  __typename?: 'OverseasProductMongooseClass';
  _id: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  agtCode: Scalars['String']['output'];
  beginDate: Scalars['String']['output'];
  beginTime?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayStatusName: Scalars['String']['output'];
  displayStatusNamePlus: Scalars['String']['output'];
  emergency?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  finalProductName: Scalars['String']['output'];
  guaranteedDeparture?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  otaCoupon?: Maybe<CouponResponse>;
  overseasBookMinSeat?: Maybe<Scalars['Int']['output']>;
  prices: ProductPrice;
  productFamily?: Maybe<OverseasProductFamilyMongooseClass>;
  productFamilyId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productStatus: ProductStatus;
  promotion?: Maybe<PromotionResponse>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OverseasProductMongooseClassProductFamilyArgs = {
  ignoreServiceActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OverseasPromotionMongooseClass = {
  __typename?: 'OverseasPromotionMongooseClass';
  _id: Scalars['String']['output'];
  activate: Scalars['Boolean']['output'];
  deletedAt: Scalars['DateTime']['output'];
  endBookingDate: Scalars['DateTime']['output'];
  endDepartureDate: Scalars['DateTime']['output'];
  nPayCond: Scalars['Int']['output'];
  nPayLimit: Scalars['Int']['output'];
  promotionId: Scalars['String']['output'];
  startBookingDate: Scalars['DateTime']['output'];
  startDepartureDate: Scalars['DateTime']['output'];
};

export type OverseasSocialProofDetailInput = {
  agtCode: Scalars['String']['input'];
  cityCode?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  productFamilyId: Scalars['String']['input'];
};

export type OverseasSocialProofDetailOutput = {
  __typename?: 'OverseasSocialProofDetailOutput';
  isBestProduct: Scalars['Boolean']['output'];
  weeklyBookingStats: WeeklyBookingStats;
};

export type OverseasSocialProofLabel = {
  __typename?: 'OverseasSocialProofLabel';
  targetIds: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OverseasSocialProofLabelInput = {
  departureDate: Scalars['String']['input'];
  departures?: InputMaybe<Array<Scalars['String']['input']>>;
  destinations?: InputMaybe<Scalars['String']['input']>;
  excludeCategories: Array<Scalars['String']['input']>;
  hashTags?: InputMaybe<Array<Scalars['String']['input']>>;
  includeCategories: Array<Scalars['String']['input']>;
  tnCodes?: InputMaybe<Scalars['String']['input']>;
};

export type OverseasSocialProofLabelOutput = {
  __typename?: 'OverseasSocialProofLabelOutput';
  productFamilyIdLabels: Array<OverseasSocialProofLabel>;
  productIdLabels: Array<OverseasSocialProofLabel>;
};

/** 페이지 정보 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** 페이지 데이타에서 해당 값의 개수만 제공 */
  first?: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  /** 페이지 데이타 중 해당 값의 개수를 생략 */
  skip?: Maybe<Scalars['Int']['output']>;
};

export type PersonalCount = {
  __typename?: 'PersonalCount';
  adult: Scalars['Int']['output'];
  child?: Maybe<Scalars['Int']['output']>;
  flexible: Scalars['Boolean']['output'];
  infant?: Maybe<Scalars['Int']['output']>;
};

export type PersonalCountInput = {
  adult: Scalars['Int']['input'];
  child?: InputMaybe<Scalars['Int']['input']>;
  flexible: Scalars['Boolean']['input'];
  infant?: InputMaybe<Scalars['Int']['input']>;
};

export type Product = DomesticProductModelClass | OverseasProductMongooseClass;

export type ProductPrice = {
  __typename?: 'ProductPrice';
  adult: Scalars['Float']['output'];
  child: Scalars['Float']['output'];
  infant: Scalars['Float']['output'];
};

export enum ProductRecommendType {
  Agegender = 'AGEGENDER',
  Agent = 'AGENT',
  Cvr = 'CVR',
  Period = 'PERIOD',
  Persontype = 'PERSONTYPE',
}

export enum ProductStatus {
  Arbkg = 'ARBKG',
  Levdc = 'LEVDC',
  Rsvcd = 'RSVCD',
  Rsvps = 'RSVPS',
}

export type PromotionResponse = {
  __typename?: 'PromotionResponse';
  /** 사용가능한 프로모션 리스트 */
  activePromotions?: Maybe<Array<OverseasPromotionMongooseClass>>;
  /** 최대 적립 대상인 프로모션 리스트 */
  maxSavingPromotions?: Maybe<Array<SavingPromotion>>;
  totalSavingRate?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  bookingAgreement?: Maybe<BookingAgreementModelClass>;
  commonHolidays: Array<Holiday>;
  customOptions?: Maybe<Array<CustomOption>>;
  customRecommend?: Maybe<Array<CustomRecommend>>;
  customRequirements?: Maybe<Array<CodeType>>;
  customTravelOverseasAgentsByCountryCodes: Array<OverseasAgentMongooseClass>;
  domesticAgent: DomesticAgentMongooseClass;
  estimateById: CustomEstimate;
  estimateGroups: Array<CustomEstimateGroupByStatus>;
  estimateGroupsByStatus: CustomEstimateGroupsResponse;
  isoCountries: Array<IsoCountry>;
  me: Me;
  myBookings: BookingUnionConnection;
  myInquiries: InquiryCount;
  mySearchHistories: Array<DisplayedSearchHistoryModelClass>;
  myZzims: Array<DisplayedZzimModelClass>;
  overseasAgent: OverseasAgentMongooseClass;
  overseasMinMaxPrice?: Maybe<MinMaxPrice>;
  overseasProduct?: Maybe<OverseasProductMongooseClass>;
  overseasProducts?: Maybe<Array<OverseasProductMongooseClass>>;
  overseasSocialProofDetail: OverseasSocialProofDetailOutput;
  overseasSocialProofLabels: OverseasSocialProofLabelOutput;
  recommendOverseasProductCategoryNames?: Maybe<Array<Scalars['String']['output']>>;
  recommendOverseasProductsByCf?: Maybe<Array<RecommendedProduct>>;
  recommendOverseasProductsByStat?: Maybe<Array<RecommendedProduct>>;
  travelClubUser: TravelClubUser;
};

export type QueryCommonHolidaysArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type QueryCustomOptionsArgs = {
  landingUrl: Scalars['String']['input'];
};

export type QueryCustomRecommendArgs = {
  cityCodes: Array<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
};

export type QueryCustomTravelOverseasAgentsByCountryCodesArgs = {
  countryCodes: Array<Scalars['String']['input']>;
  excludeLandingUrls?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryDomesticAgentArgs = {
  landingUrl: Scalars['String']['input'];
};

export type QueryEstimateByIdArgs = {
  estimateId: Scalars['String']['input'];
};

export type QueryEstimateGroupsByStatusArgs = {
  estimateStatus: Array<EstimateStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InputEstimateSortOptions>;
};

export type QueryMyBookingsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InputBookingSortOptions>;
};

export type QueryMyZzimsArgs = {
  sort: ZzimSortOptions;
};

export type QueryOverseasAgentArgs = {
  landingUrl: Scalars['String']['input'];
};

export type QueryOverseasMinMaxPriceArgs = {
  maxDate: Scalars['String']['input'];
  minDate: Scalars['String']['input'];
  productFamilyId: Scalars['String']['input'];
  productStatus?: InputMaybe<Array<ProductStatus>>;
};

export type QueryOverseasProductArgs = {
  landingUrl: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type QueryOverseasProductsArgs = {
  maxDate?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['String']['input']>;
  productFamilyId: Scalars['String']['input'];
  productStatus: Array<ProductStatus>;
};

export type QueryOverseasSocialProofDetailArgs = {
  params: OverseasSocialProofDetailInput;
};

export type QueryOverseasSocialProofLabelsArgs = {
  searchParams: OverseasSocialProofLabelInput;
};

export type QueryRecommendOverseasProductCategoryNamesArgs = {
  agtCode?: InputMaybe<Scalars['String']['input']>;
  departureMonth: Scalars['String']['input'];
  destinations?: InputMaybe<Array<Scalars['String']['input']>>;
  period?: InputMaybe<Scalars['String']['input']>;
  recommendType: ProductRecommendType;
};

export type QueryRecommendOverseasProductsByCfArgs = {
  departureMonth: Scalars['String']['input'];
  productFamilyId: Scalars['String']['input'];
};

export type QueryRecommendOverseasProductsByStatArgs = {
  agtCode?: InputMaybe<Scalars['String']['input']>;
  categoryName: Scalars['String']['input'];
  departureMonth: Scalars['String']['input'];
  destinations?: InputMaybe<Array<Scalars['String']['input']>>;
  period?: InputMaybe<Scalars['String']['input']>;
  recommendType: ProductRecommendType;
};

export type RecommendType = {
  __typename?: 'RecommendType';
  dayPeriod?: Maybe<Scalars['Int']['output']>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  nightPeriod?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type RecommendedProduct = {
  __typename?: 'RecommendedProduct';
  agtCode: Scalars['String']['output'];
  agtName: Scalars['String']['output'];
  categoryLabelColorType: Scalars['String']['output'];
  couponPrice?: Maybe<Array<RecommendedProductCouponPrice>>;
  discountRateText: Scalars['String']['output'];
  landingUrl: Scalars['String']['output'];
  orgPrice: Scalars['Float']['output'];
  period: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  productFamilyId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  rank: Scalars['Float']['output'];
  thumbnail: Scalars['String']['output'];
  tourCategoryName: Scalars['String']['output'];
  visitSummary: Scalars['String']['output'];
};

export type RecommendedProductLandingUrlArgs = {
  device?: InputMaybe<Scalars['String']['input']>;
};

export type RecommendedProductCouponPrice = {
  __typename?: 'RecommendedProductCouponPrice';
  discountRateText: Scalars['String']['output'];
  grade: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
};

export type Ride = {
  __typename?: 'Ride';
  code: Scalars['String']['output'];
  extra: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SavingPaypointModelClass = {
  __typename?: 'SavingPaypointModelClass';
  agtCode: Scalars['String']['output'];
  bizType: TravelClubPaypointBizType;
  bookingId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isSavingPossible: Scalars['Boolean']['output'];
  nidNo: Scalars['String']['output'];
  savingAmount: Scalars['Int']['output'];
  savingPossibleDate: Scalars['String']['output'];
};

export type SavingPromotion = {
  __typename?: 'SavingPromotion';
  nPayCond: Scalars['Int']['output'];
  nPayLimit: Scalars['Int']['output'];
  promotionId?: Maybe<Scalars['String']['output']>;
};

export type Schedule = {
  __typename?: 'Schedule';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type ScheduleInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type Shopping = {
  __typename?: 'Shopping';
  count?: Maybe<Scalars['Float']['output']>;
};

export type SmsVerificationInfoGraphqlType = {
  __typename?: 'SmsVerificationInfoGraphqlType';
  tradeId: Scalars['String']['output'];
};

export type Term = {
  isAgree: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type Tips = {
  __typename?: 'Tips';
  include: Scalars['Boolean']['output'];
};

export type TourCategory = {
  __typename?: 'TourCategory';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TourSchedule = {
  __typename?: 'TourSchedule';
  flexible: Scalars['Boolean']['output'];
  schedules: Array<Schedule>;
};

export type TourScheduleInput = {
  flexible: Scalars['Boolean']['input'];
  schedules: Array<ScheduleInput>;
};

export enum TravelClubPaypointBizType {
  Domestic = 'DOMESTIC',
  Overseas = 'OVERSEAS',
}

export type TravelClubPaypointModelClass = {
  __typename?: 'TravelClubPaypointModelClass';
  agtCode: Scalars['String']['output'];
  bizType: TravelClubPaypointBizType;
  bookingId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  isSavingPossible: Scalars['Boolean']['output'];
  nidNo: Scalars['String']['output'];
  savingAmount: Scalars['Float']['output'];
  savingPossibleDate: Scalars['String']['output'];
  savingRate: Scalars['Float']['output'];
};

export type TravelClubUser = {
  __typename?: 'TravelClubUser';
  grade: Scalars['Float']['output'];
  gradeKo: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nickName: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  createTime: Scalars['DateTime']['output'];
  /** 네이버 유저 식별자(NidNo) */
  id: Scalars['ID']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  node: User;
};

export type VerifySmsGraphqlType = {
  __typename?: 'VerifySmsGraphqlType';
  isValid: Scalars['Boolean']['output'];
};

export type VisitAreaType = {
  __typename?: 'VisitAreaType';
  cityCode: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
};

export type WeeklyBookingStats = {
  __typename?: 'WeeklyBookingStats';
  aggPeriod: Scalars['Float']['output'];
  numberOfPeople: Scalars['Float']['output'];
  weeks: Scalars['Float']['output'];
};

export enum ZzimSortOptionFields {
  BeginDate = 'BEGIN_DATE',
  Price = 'PRICE',
}

export type ZzimSortOptions = {
  fieldName: ZzimSortOptionFields;
  order?: InputMaybe<MongoSortOptions>;
};

export type OverseasRegionCallNums = {
  __typename?: 'overseasRegionCallNums';
  callNum: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type DeleteAllInActiveBookingsMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteAllInActiveBookingsMutation = {
  __typename?: 'Mutation';
  deleteAllInActiveBookings: Array<
    | {
        __typename?: 'DomesticBooking';
        id: string;
        bookingId: string;
        deleted?: boolean | null;
        updatedDate?: any | null;
      }
    | {
        __typename?: 'OverseasBooking';
        id: string;
        bookingId: string;
        deleted?: boolean | null;
        updatedDate?: any | null;
      }
  >;
};

export type MyBookingsQueryVariables = Exact<{
  isActive: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InputBookingSortOptions>;
}>;

export type MyBookingsQuery = {
  __typename?: 'Query';
  myBookings: {
    __typename?: 'BookingUnionConnection';
    totalCount: number;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges?: Array<{
      __typename?: 'BookingUnionEdge';
      node:
        | {
            __typename?: 'DomesticBooking';
            id: string;
            bookingId: string;
            bookingStatus: BookingStatus;
            bookingDate: any;
            productType?: BooKingProductType | null;
            isActive: boolean;
            deleted?: boolean | null;
            fareInfo: {
              __typename?: 'DomesticBookingFareInfo';
              adult: number;
              child: number;
              infant: number;
              totalFare: number;
            };
            agent: {
              __typename?: 'DomesticAgentMongooseClass';
              id: string;
              name: string;
              tel: string;
              landingUrl: string;
              inquiryInfo?: string | null;
              taxNum?: string | null;
              isSoleTrader?: boolean | null;
              representative?: string | null;
              representativeBirth?: string | null;
              addr?: string | null;
              email?: string | null;
              mailOrderSalesNum?: string | null;
              tourBusinessNum?: string | null;
              inquiryAvailableTime?: string | null;
              inquiryUnavailableTime?: string | null;
              inquiryLunchTime?: string | null;
              isCallCenterActive?: boolean | null;
              preBookingTarget?: string | null;
              mainCallNum?: string | null;
              mainCallDesc?: Array<string> | null;
              kakaoPlusFriendId?: string | null;
              bookingTarget?: string | null;
              bookingCallDesc?: string | null;
              bookingCallMethod?: string | null;
              mainCallFailDesc?: string | null;
              regionCallFailDesc?: string | null;
              regionCallNums?: Array<{ __typename?: 'DomesticregionCallNums'; region: string; callNum: string }> | null;
            };
            product?: {
              __typename?: 'DomesticProductModelClass';
              id: string;
              productId: string;
              productStatus: ProductStatus;
              displayStatusName: string;
              productName: string;
              finalProductName: string;
              beginDate: string;
              endDate?: string | null;
              agtCode: string;
              productFamilyId: string;
              productFamily?: {
                __typename?: 'DomesticProductFamilyModelClass';
                id: string;
                nightPeriod: number;
                dayPeriod: number;
                firstImage: string;
              } | null;
            } | null;
            statusLabel?: { __typename?: 'BookingStatusLabel'; name: string; color: string } | null;
            travelClubPaypoint?: {
              __typename?: 'TravelClubPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
            savingPaypoint?: {
              __typename?: 'SavingPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
          }
        | {
            __typename?: 'OverseasBooking';
            id: string;
            bookingId: string;
            bookingStatus: BookingStatus;
            bookingDate: any;
            productType?: BooKingProductType | null;
            isActive: boolean;
            deleted?: boolean | null;
            voucherUrl?: string | null;
            fareInfo: {
              __typename?: 'OverseasBookingFareInfo';
              adult: number;
              child: number;
              infant: number;
              remainingAmount: number;
              totalFare: number;
            };
            agent: {
              __typename?: 'OverseasAgentMongooseClass';
              id: string;
              name: string;
              tel: string;
              landingUrl: string;
              inquiryInfo?: string | null;
              taxNum?: string | null;
              isSoleTrader?: boolean | null;
              representative?: string | null;
              representativeBirth?: string | null;
              addr?: string | null;
              email?: string | null;
              mailOrderSalesNum?: string | null;
              tourBusinessNum?: string | null;
              inquiryAvailableTime?: string | null;
              inquiryUnavailableTime?: string | null;
              inquiryLunchTime?: string | null;
              isCallCenterActive?: boolean | null;
              preBookingTarget?: string | null;
              mainCallNum?: string | null;
              mainCallDesc?: Array<string> | null;
              kakaoPlusFriendId?: string | null;
              bookingTarget?: string | null;
              bookingCallDesc?: string | null;
              bookingCallMethod?: string | null;
              mainCallFailDesc?: string | null;
              regionCallFailDesc?: string | null;
              regionCallNums?: Array<{ __typename?: 'overseasRegionCallNums'; region: string; callNum: string }> | null;
            };
            product?: {
              __typename?: 'OverseasProductMongooseClass';
              id: string;
              productId: string;
              productStatus: ProductStatus;
              displayStatusName: string;
              productName: string;
              finalProductName: string;
              beginDate: string;
              endDate?: string | null;
              agtCode: string;
              productFamilyId: string;
              productFamily?: {
                __typename?: 'OverseasProductFamilyMongooseClass';
                id: string;
                nightPeriod: number;
                dayPeriod: number;
                firstImage: string;
              } | null;
            } | null;
            statusLabel?: { __typename?: 'BookingStatusLabel'; name: string; color: string } | null;
            travelClubPaypoint?: {
              __typename?: 'TravelClubPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
            savingPaypoint?: {
              __typename?: 'SavingPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
          };
    }> | null;
  };
};

export type AccumulatePaypointMutationVariables = Exact<{
  agtCode: Scalars['String']['input'];
  bookingId: Scalars['String']['input'];
  bizType: TravelClubPaypointBizType;
  isSavingPromotionPaypoint: Scalars['Boolean']['input'];
  isTravelClubPaypoint: Scalars['Boolean']['input'];
}>;

export type AccumulatePaypointMutation = {
  __typename?: 'Mutation';
  accumulateSavingPaypoint?: {
    __typename?: 'SavingPaypointModelClass';
    id: string;
    isPaid: boolean;
    savingAmount: number;
  };
  accumulateTravelClubPaypoint?: {
    __typename?: 'TravelClubPaypointModelClass';
    id: string;
    isPaid: boolean;
    savingAmount: number;
  };
};

export type GetBookingAgreementQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookingAgreementQuery = {
  __typename?: 'Query';
  bookingAgreement?: { __typename?: 'BookingAgreementModelClass'; id: string; ts?: string | null } | null;
};

export type SaveBookingAgreementMutationVariables = Exact<{ [key: string]: never }>;

export type SaveBookingAgreementMutation = {
  __typename?: 'Mutation';
  saveBookingAgreement: { __typename?: 'BookingAgreementModelClass'; id: string; ts?: string | null };
};

export type Pkgtour_Custom_Delete_Estimates_By_IdsMutationVariables = Exact<{
  estimateIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type Pkgtour_Custom_Delete_Estimates_By_IdsMutation = { __typename?: 'Mutation'; deleteEstimates: boolean };

export type DeleteMyBookingMutationVariables = Exact<{
  bookingId: Scalars['String']['input'];
  bookingProductType: BooKingProductType;
}>;

export type DeleteMyBookingMutation = {
  __typename?: 'Mutation';
  deleteBooking:
    | {
        __typename?: 'DomesticBooking';
        id: string;
        bookingId: string;
        deleted?: boolean | null;
        updatedDate?: any | null;
      }
    | {
        __typename?: 'OverseasBooking';
        id: string;
        bookingId: string;
        deleted?: boolean | null;
        updatedDate?: any | null;
      };
};

export type Pkgtour_Custom_EstimatesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InputEstimateSortOptions>;
  estimateStatus: Array<EstimateStatus> | EstimateStatus;
}>;

export type Pkgtour_Custom_EstimatesQuery = {
  __typename?: 'Query';
  estimateGroupsByStatus: {
    __typename?: 'CustomEstimateGroupsResponse';
    totalCount: number;
    groupEstimates: Array<{
      __typename?: 'CustomEstimateGroupByStatus';
      estimateGroupId: string;
      groupType: { __typename?: 'CodeName'; code: string; name: string };
      personalCount?: {
        __typename?: 'PersonalCount';
        adult: number;
        infant?: number | null;
        child?: number | null;
      } | null;
      budget?: { __typename?: 'Budget'; amount: number; budgetType?: string | null; flexibility: string } | null;
      destinations?: Array<{
        __typename?: 'CodesOptionalName';
        codes?: Array<string> | null;
        name?: string | null;
      }> | null;
      estimates: Array<{
        __typename?: 'CustomEstimate';
        id: string;
        estimateRequestAgtCode: string;
        estimateId: string;
        estimateStatus: EstimateStatus;
        dayDiff?: number | null;
        createdAt: any;
        createdAtStr: string;
        activeReceivedAlert: boolean;
        customizeProduct?: {
          __typename?: 'CustomProduct';
          productId: string;
          beginDate: string;
          endDate?: string | null;
          productName: string;
          beginDateStr: string;
          endDateStr?: string | null;
          updatedAtStr: string;
          prices: { __typename?: 'ProductPrice'; adult: number; infant: number; child: number };
        } | null;
        customizeProductFamily?: {
          __typename?: 'CustomProductFamily';
          image?: string | null;
          dayPeriod: number;
          nightPeriod: number;
          airline?: { __typename?: 'CodeName'; name: string; code: string } | null;
        } | null;
        requestAgent: {
          __typename?: 'CustomAgent';
          name: string;
          agtCode: string;
          tel: string;
          landingUrl: string;
          agtLogoUrl: string;
        };
        customizeAgent?: { __typename?: 'CustomAgent'; landingUrl: string } | null;
      }>;
    }>;
  };
};

export type GroupEstimateFragment = {
  __typename?: 'CustomEstimateGroupByStatus';
  estimateGroupId: string;
  groupType: { __typename?: 'CodeName'; code: string; name: string };
  personalCount?: { __typename?: 'PersonalCount'; adult: number; infant?: number | null; child?: number | null } | null;
  budget?: { __typename?: 'Budget'; amount: number; budgetType?: string | null; flexibility: string } | null;
  destinations?: Array<{ __typename?: 'CodesOptionalName'; codes?: Array<string> | null; name?: string | null }> | null;
  estimates: Array<{
    __typename?: 'CustomEstimate';
    id: string;
    estimateRequestAgtCode: string;
    estimateId: string;
    estimateStatus: EstimateStatus;
    dayDiff?: number | null;
    createdAt: any;
    createdAtStr: string;
    activeReceivedAlert: boolean;
    customizeProduct?: {
      __typename?: 'CustomProduct';
      productId: string;
      beginDate: string;
      endDate?: string | null;
      productName: string;
      beginDateStr: string;
      endDateStr?: string | null;
      updatedAtStr: string;
      prices: { __typename?: 'ProductPrice'; adult: number; infant: number; child: number };
    } | null;
    customizeProductFamily?: {
      __typename?: 'CustomProductFamily';
      image?: string | null;
      dayPeriod: number;
      nightPeriod: number;
      airline?: { __typename?: 'CodeName'; name: string; code: string } | null;
    } | null;
    requestAgent: {
      __typename?: 'CustomAgent';
      name: string;
      agtCode: string;
      tel: string;
      landingUrl: string;
      agtLogoUrl: string;
    };
    customizeAgent?: { __typename?: 'CustomAgent'; landingUrl: string } | null;
  }>;
};

export type Pkgtour_Custom_Delete_EstimatesMutationVariables = Exact<{
  estimateStatus: Array<EstimateStatus> | EstimateStatus;
}>;

export type Pkgtour_Custom_Delete_EstimatesMutation = { __typename?: 'Mutation'; deleteEstimatesByStatus: boolean };

export type GetCustomInitQueryVariables = Exact<{
  landingUrl: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetCustomInitQuery = {
  __typename?: 'Query';
  customOptions?: Array<{
    __typename?: 'CustomOption';
    groupType: string;
    groupName: string;
    groupDescription: string;
    specialNotes: Array<{ __typename?: 'CodeType'; name: string; code: string; isDirectInput: boolean }>;
    mealOrShoppings: Array<{ __typename?: 'CodeType'; name: string; code: string }>;
    additionalRequirementCheckList: Array<{ __typename?: 'CodeType'; code: string; name: string }>;
  }> | null;
  customRequirements?: Array<{ __typename?: 'CodeType'; code: string; name: string }> | null;
  overseasProduct?: {
    __typename?: 'OverseasProductMongooseClass';
    _id: string;
    agtCode: string;
    productId: string;
    productFamilyId: string;
    productName: string;
    beginDate: string;
    endDate?: string | null;
    overseasBookMinSeat?: number | null;
    productFamily?: {
      __typename?: 'OverseasProductFamilyMongooseClass';
      _id: string;
      images: Array<string>;
      visitCountryCodes: Array<string>;
      customTravelType?: CustomTravelType | null;
      visitAreas: Array<{
        __typename?: 'VisitAreaType';
        cityName: string;
        cityCode: string;
        countryName: string;
        countryCode: string;
      }>;
    } | null;
  } | null;
  overseasAgent: {
    __typename?: 'OverseasAgentMongooseClass';
    _id: string;
    agtCode: string;
    customActive?: boolean | null;
    customGroupTypes?: Array<GroupType> | null;
    customKakaoActive?: boolean | null;
    agtLogoUrl: string;
    name: string;
  };
};

export type CustomRecommendQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  cityCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type CustomRecommendQuery = {
  __typename?: 'Query';
  customRecommend?: Array<{
    __typename?: 'CustomRecommend';
    countryCode: string;
    cityCodes: Array<string>;
    name: string;
    minOrder: number;
    recommends?: Array<{
      __typename?: 'RecommendType';
      dayPeriod?: number | null;
      nightPeriod?: number | null;
      month?: number | null;
      minPrice?: number | null;
      maxPrice?: number | null;
      order?: number | null;
    }> | null;
  }> | null;
};

export type GetCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCountriesQuery = {
  __typename?: 'Query';
  isoCountries: Array<{
    __typename?: 'IsoCountry';
    id: string;
    countryNo: number;
    countryName: string;
    isDefaultValue: boolean;
  }>;
};

export type GetHolidaysQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;

export type GetHolidaysQuery = {
  __typename?: 'Query';
  commonHolidays: Array<{ __typename?: 'Holiday'; id: string; name: string; date: string; type: string }>;
};

export type GetTravelClubUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetTravelClubUserQuery = {
  __typename?: 'Query';
  travelClubUser: { __typename?: 'TravelClubUser'; id: string; nickName: string; grade: number; gradeKo: string };
  me: { __typename?: 'Me'; id?: string | null; canUseCustomTravel: boolean; isLogin: boolean };
};

export type GetCustomEstimateProductQueryVariables = Exact<{
  estimateId: Scalars['String']['input'];
}>;

export type GetCustomEstimateProductQuery = {
  __typename?: 'Query';
  travelClubUser: { __typename?: 'TravelClubUser'; id: string; nickName: string; grade: number; gradeKo: string };
  me: { __typename?: 'Me'; id?: string | null; canUseCustomTravel: boolean; isLogin: boolean };
  estimateById: {
    __typename?: 'CustomEstimate';
    id: string;
    estimateId: string;
    estimateType: CustomEstimateType;
    estimateStatus: EstimateStatus;
    dayDiff?: number | null;
    visitAreaNames?: string | null;
    thumbnailUrl: string;
    inquireUrl?: string | null;
    estimateDetailUrl?: string | null;
    estimateStatusInfo?: string | null;
    additionalRequirements?: string | null;
    activeReceivedAlert: boolean;
    estimateDownloadUrl?: string | null;
    groupType: { __typename?: 'CodeName'; code: string; name: string };
    destinations?: Array<{
      __typename?: 'CodesOptionalName';
      codes?: Array<string> | null;
      name?: string | null;
    }> | null;
    tourSchedule?: {
      __typename?: 'TourSchedule';
      flexible: boolean;
      schedules: Array<{ __typename?: 'Schedule'; from: string; to: string }>;
    } | null;
    contact: {
      __typename?: 'CustomContact';
      channel: string;
      preferredHourRange: Array<{ __typename?: 'CustomHourRange'; from: number; to: number }>;
    };
    budget?: { __typename?: 'Budget'; amount: number; budgetType?: string | null; flexibility: string } | null;
    personalCount?: {
      __typename?: 'PersonalCount';
      adult: number;
      child?: number | null;
      infant?: number | null;
      flexible: boolean;
    } | null;
    flight?: { __typename?: 'CustomFlight'; airlineType: string; preferredAirlines?: Array<string> | null } | null;
    hotel?: { __typename?: 'CustomHotel'; minStarRate?: number | null; preferredHotels?: Array<string> | null } | null;
    mealOrShoppings?: Array<{ __typename?: 'CodeName'; code: string; name: string }> | null;
    requestAgent: { __typename?: 'CustomAgent'; agtLogoUrl: string };
    additionalRequirementCheckList?: Array<{ __typename?: 'CodeName'; code: string; name: string }> | null;
    customizeAgent?: { __typename?: 'CustomAgent'; landingUrl: string } | null;
    customizeProduct?: {
      __typename?: 'CustomProduct';
      productId: string;
      productName: string;
      beginDateStr: string;
      endDateStr?: string | null;
      updatedAtStr: string;
      beginDate: string;
      updatedAt: any;
      prices: { __typename?: 'ProductPrice'; adult: number; infant: number; child: number };
    } | null;
    customizeProductFamily?: {
      __typename?: 'CustomProductFamily';
      image?: string | null;
      images: Array<string>;
      dayPeriod: number;
      nightPeriod: number;
      airline?: { __typename?: 'CodeName'; name: string; code: string } | null;
    } | null;
  };
};

export type GetCustomTravelInitialPageQueryQueryVariables = Exact<{
  landingUrl: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetCustomTravelInitialPageQueryQuery = {
  __typename?: 'Query';
  travelClubUser: { __typename?: 'TravelClubUser'; id: string; nickName: string; grade: number; gradeKo: string };
  me: { __typename?: 'Me'; id?: string | null; canUseCustomTravel: boolean; isLogin: boolean };
  customOptions?: Array<{
    __typename?: 'CustomOption';
    groupType: string;
    groupName: string;
    groupDescription: string;
    specialNotes: Array<{ __typename?: 'CodeType'; name: string; code: string; isDirectInput: boolean }>;
    mealOrShoppings: Array<{ __typename?: 'CodeType'; name: string; code: string }>;
    additionalRequirementCheckList: Array<{ __typename?: 'CodeType'; code: string; name: string }>;
  }> | null;
  customRequirements?: Array<{ __typename?: 'CodeType'; code: string; name: string }> | null;
  overseasProduct?: {
    __typename?: 'OverseasProductMongooseClass';
    _id: string;
    agtCode: string;
    productId: string;
    productFamilyId: string;
    productName: string;
    beginDate: string;
    endDate?: string | null;
    overseasBookMinSeat?: number | null;
    productFamily?: {
      __typename?: 'OverseasProductFamilyMongooseClass';
      _id: string;
      images: Array<string>;
      visitCountryCodes: Array<string>;
      customTravelType?: CustomTravelType | null;
      visitAreas: Array<{
        __typename?: 'VisitAreaType';
        cityName: string;
        cityCode: string;
        countryName: string;
        countryCode: string;
      }>;
    } | null;
  } | null;
  overseasAgent: {
    __typename?: 'OverseasAgentMongooseClass';
    _id: string;
    agtCode: string;
    customActive?: boolean | null;
    customGroupTypes?: Array<GroupType> | null;
    customKakaoActive?: boolean | null;
    agtLogoUrl: string;
    name: string;
  };
};

export type GetMyBookingsInitialPageQueryQueryVariables = Exact<{
  sort?: InputMaybe<InputBookingSortOptions>;
}>;

export type GetMyBookingsInitialPageQueryQuery = {
  __typename?: 'Query';
  travelClubUser: { __typename?: 'TravelClubUser'; id: string; nickName: string; grade: number; gradeKo: string };
  me: { __typename?: 'Me'; id?: string | null; canUseCustomTravel: boolean; isLogin: boolean };
  bookingAgreement?: { __typename?: 'BookingAgreementModelClass'; id: string; ts?: string | null } | null;
  myActiveBookings: {
    __typename?: 'BookingUnionConnection';
    totalCount: number;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges?: Array<{
      __typename?: 'BookingUnionEdge';
      node:
        | {
            __typename?: 'DomesticBooking';
            id: string;
            bookingId: string;
            bookingStatus: BookingStatus;
            bookingDate: any;
            productType?: BooKingProductType | null;
            isActive: boolean;
            deleted?: boolean | null;
            fareInfo: {
              __typename?: 'DomesticBookingFareInfo';
              adult: number;
              child: number;
              infant: number;
              totalFare: number;
            };
            agent: {
              __typename?: 'DomesticAgentMongooseClass';
              id: string;
              name: string;
              tel: string;
              landingUrl: string;
              inquiryInfo?: string | null;
              taxNum?: string | null;
              isSoleTrader?: boolean | null;
              representative?: string | null;
              representativeBirth?: string | null;
              addr?: string | null;
              email?: string | null;
              mailOrderSalesNum?: string | null;
              tourBusinessNum?: string | null;
              inquiryAvailableTime?: string | null;
              inquiryUnavailableTime?: string | null;
              inquiryLunchTime?: string | null;
              isCallCenterActive?: boolean | null;
              preBookingTarget?: string | null;
              mainCallNum?: string | null;
              mainCallDesc?: Array<string> | null;
              kakaoPlusFriendId?: string | null;
              bookingTarget?: string | null;
              bookingCallDesc?: string | null;
              bookingCallMethod?: string | null;
              mainCallFailDesc?: string | null;
              regionCallFailDesc?: string | null;
              regionCallNums?: Array<{ __typename?: 'DomesticregionCallNums'; region: string; callNum: string }> | null;
            };
            product?: {
              __typename?: 'DomesticProductModelClass';
              id: string;
              productId: string;
              productStatus: ProductStatus;
              displayStatusName: string;
              productName: string;
              finalProductName: string;
              beginDate: string;
              endDate?: string | null;
              agtCode: string;
              productFamilyId: string;
              productFamily?: {
                __typename?: 'DomesticProductFamilyModelClass';
                id: string;
                nightPeriod: number;
                dayPeriod: number;
                firstImage: string;
              } | null;
            } | null;
            statusLabel?: { __typename?: 'BookingStatusLabel'; name: string; color: string } | null;
            travelClubPaypoint?: {
              __typename?: 'TravelClubPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
            savingPaypoint?: {
              __typename?: 'SavingPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
          }
        | {
            __typename?: 'OverseasBooking';
            id: string;
            bookingId: string;
            bookingStatus: BookingStatus;
            bookingDate: any;
            productType?: BooKingProductType | null;
            isActive: boolean;
            deleted?: boolean | null;
            voucherUrl?: string | null;
            fareInfo: {
              __typename?: 'OverseasBookingFareInfo';
              adult: number;
              child: number;
              infant: number;
              remainingAmount: number;
              totalFare: number;
            };
            agent: {
              __typename?: 'OverseasAgentMongooseClass';
              id: string;
              name: string;
              tel: string;
              landingUrl: string;
              inquiryInfo?: string | null;
              taxNum?: string | null;
              isSoleTrader?: boolean | null;
              representative?: string | null;
              representativeBirth?: string | null;
              addr?: string | null;
              email?: string | null;
              mailOrderSalesNum?: string | null;
              tourBusinessNum?: string | null;
              inquiryAvailableTime?: string | null;
              inquiryUnavailableTime?: string | null;
              inquiryLunchTime?: string | null;
              isCallCenterActive?: boolean | null;
              preBookingTarget?: string | null;
              mainCallNum?: string | null;
              mainCallDesc?: Array<string> | null;
              kakaoPlusFriendId?: string | null;
              bookingTarget?: string | null;
              bookingCallDesc?: string | null;
              bookingCallMethod?: string | null;
              mainCallFailDesc?: string | null;
              regionCallFailDesc?: string | null;
              regionCallNums?: Array<{ __typename?: 'overseasRegionCallNums'; region: string; callNum: string }> | null;
            };
            product?: {
              __typename?: 'OverseasProductMongooseClass';
              id: string;
              productId: string;
              productStatus: ProductStatus;
              displayStatusName: string;
              productName: string;
              finalProductName: string;
              beginDate: string;
              endDate?: string | null;
              agtCode: string;
              productFamilyId: string;
              productFamily?: {
                __typename?: 'OverseasProductFamilyMongooseClass';
                id: string;
                nightPeriod: number;
                dayPeriod: number;
                firstImage: string;
              } | null;
            } | null;
            statusLabel?: { __typename?: 'BookingStatusLabel'; name: string; color: string } | null;
            travelClubPaypoint?: {
              __typename?: 'TravelClubPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
            savingPaypoint?: {
              __typename?: 'SavingPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
          };
    }> | null;
  };
  myInactiveBooking: {
    __typename?: 'BookingUnionConnection';
    totalCount: number;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges?: Array<{
      __typename?: 'BookingUnionEdge';
      node:
        | {
            __typename?: 'DomesticBooking';
            id: string;
            bookingId: string;
            bookingStatus: BookingStatus;
            bookingDate: any;
            productType?: BooKingProductType | null;
            isActive: boolean;
            deleted?: boolean | null;
            fareInfo: {
              __typename?: 'DomesticBookingFareInfo';
              adult: number;
              child: number;
              infant: number;
              totalFare: number;
            };
            agent: {
              __typename?: 'DomesticAgentMongooseClass';
              id: string;
              name: string;
              tel: string;
              landingUrl: string;
              inquiryInfo?: string | null;
              taxNum?: string | null;
              isSoleTrader?: boolean | null;
              representative?: string | null;
              representativeBirth?: string | null;
              addr?: string | null;
              email?: string | null;
              mailOrderSalesNum?: string | null;
              tourBusinessNum?: string | null;
              inquiryAvailableTime?: string | null;
              inquiryUnavailableTime?: string | null;
              inquiryLunchTime?: string | null;
              isCallCenterActive?: boolean | null;
              preBookingTarget?: string | null;
              mainCallNum?: string | null;
              mainCallDesc?: Array<string> | null;
              kakaoPlusFriendId?: string | null;
              bookingTarget?: string | null;
              bookingCallDesc?: string | null;
              bookingCallMethod?: string | null;
              mainCallFailDesc?: string | null;
              regionCallFailDesc?: string | null;
              regionCallNums?: Array<{ __typename?: 'DomesticregionCallNums'; region: string; callNum: string }> | null;
            };
            product?: {
              __typename?: 'DomesticProductModelClass';
              id: string;
              productId: string;
              productStatus: ProductStatus;
              displayStatusName: string;
              productName: string;
              finalProductName: string;
              beginDate: string;
              endDate?: string | null;
              agtCode: string;
              productFamilyId: string;
              productFamily?: {
                __typename?: 'DomesticProductFamilyModelClass';
                id: string;
                nightPeriod: number;
                dayPeriod: number;
                firstImage: string;
              } | null;
            } | null;
            statusLabel?: { __typename?: 'BookingStatusLabel'; name: string; color: string } | null;
            travelClubPaypoint?: {
              __typename?: 'TravelClubPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
            savingPaypoint?: {
              __typename?: 'SavingPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
          }
        | {
            __typename?: 'OverseasBooking';
            id: string;
            bookingId: string;
            bookingStatus: BookingStatus;
            bookingDate: any;
            productType?: BooKingProductType | null;
            isActive: boolean;
            deleted?: boolean | null;
            voucherUrl?: string | null;
            fareInfo: {
              __typename?: 'OverseasBookingFareInfo';
              adult: number;
              child: number;
              infant: number;
              remainingAmount: number;
              totalFare: number;
            };
            agent: {
              __typename?: 'OverseasAgentMongooseClass';
              id: string;
              name: string;
              tel: string;
              landingUrl: string;
              inquiryInfo?: string | null;
              taxNum?: string | null;
              isSoleTrader?: boolean | null;
              representative?: string | null;
              representativeBirth?: string | null;
              addr?: string | null;
              email?: string | null;
              mailOrderSalesNum?: string | null;
              tourBusinessNum?: string | null;
              inquiryAvailableTime?: string | null;
              inquiryUnavailableTime?: string | null;
              inquiryLunchTime?: string | null;
              isCallCenterActive?: boolean | null;
              preBookingTarget?: string | null;
              mainCallNum?: string | null;
              mainCallDesc?: Array<string> | null;
              kakaoPlusFriendId?: string | null;
              bookingTarget?: string | null;
              bookingCallDesc?: string | null;
              bookingCallMethod?: string | null;
              mainCallFailDesc?: string | null;
              regionCallFailDesc?: string | null;
              regionCallNums?: Array<{ __typename?: 'overseasRegionCallNums'; region: string; callNum: string }> | null;
            };
            product?: {
              __typename?: 'OverseasProductMongooseClass';
              id: string;
              productId: string;
              productStatus: ProductStatus;
              displayStatusName: string;
              productName: string;
              finalProductName: string;
              beginDate: string;
              endDate?: string | null;
              agtCode: string;
              productFamilyId: string;
              productFamily?: {
                __typename?: 'OverseasProductFamilyMongooseClass';
                id: string;
                nightPeriod: number;
                dayPeriod: number;
                firstImage: string;
              } | null;
            } | null;
            statusLabel?: { __typename?: 'BookingStatusLabel'; name: string; color: string } | null;
            travelClubPaypoint?: {
              __typename?: 'TravelClubPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
            savingPaypoint?: {
              __typename?: 'SavingPaypointModelClass';
              id: string;
              bizType: TravelClubPaypointBizType;
              agtCode: string;
              savingPossibleDate: string;
              isSavingPossible: boolean;
              savingAmount: number;
              isPaid: boolean;
              bookingId: string;
            } | null;
          };
    }> | null;
  };
};

export type GetMyZzimsPageQueryVariables = Exact<{
  sort: ZzimSortOptions;
}>;

export type GetMyZzimsPageQuery = {
  __typename?: 'Query';
  travelClubUser: { __typename?: 'TravelClubUser'; id: string; nickName: string; grade: number; gradeKo: string };
  me: { __typename?: 'Me'; id?: string | null; canUseCustomTravel: boolean; isLogin: boolean };
  myZzims: Array<{
    __typename?: 'DisplayedZzimModelClass';
    snapshotPrice: number;
    updateDate: any;
    isDomestic: boolean;
    bookingUrl?: string | null;
    daysSinceZzimDay: number;
    expired: boolean;
    product:
      | {
          __typename?: 'DomesticProductModelClass';
          productId: string;
          agtCode: string;
          productName: string;
          finalProductName: string;
          finalProductStatus: string;
          beginDate: string;
          endDate?: string | null;
          price: number;
          specialPrice: boolean;
          durationString: string;
          bookMinSeat: number;
          productFamily?: {
            __typename?: 'DomesticProductFamilyModelClass';
            departureCityName: string;
            nightPeriod: number;
            dayPeriod: number;
            firstImage: string;
            customRate?: boolean | null;
          } | null;
        }
      | {
          __typename?: 'OverseasProductMongooseClass';
          productId: string;
          agtCode: string;
          productName: string;
          finalProductName: string;
          productStatus: ProductStatus;
          beginTime?: string | null;
          beginDate: string;
          endDate?: string | null;
          updatedAt: any;
          emergency?: boolean | null;
          overseasBookMinSeat?: number | null;
          prices: { __typename?: 'ProductPrice'; adult: number };
          productFamily?: {
            __typename?: 'OverseasProductFamilyMongooseClass';
            nightPeriod: number;
            dayPeriod: number;
            firstImage: string;
            beginCityName?: string | null;
            customRate?: boolean | null;
            isTicketpassImmediately?: boolean | null;
            isTicketpass?: boolean | null;
            tips?: { __typename?: 'Tips'; include: boolean } | null;
            shopping?: { __typename?: 'Shopping'; count?: number | null } | null;
            ride?: { __typename?: 'Ride'; type: string; code: string; name: string; extra: string } | null;
            visitAreas: Array<{ __typename?: 'VisitAreaType'; cityName: string }>;
            tourCategory: { __typename?: 'TourCategory'; code: string };
          } | null;
        };
    agent:
      | {
          __typename?: 'DomesticAgentMongooseClass';
          landingUrl: string;
          talkTalkId?: string | null;
          talkTalkActive?: boolean | null;
        }
      | {
          __typename?: 'OverseasAgentMongooseClass';
          landingUrl: string;
          talkTalkId?: string | null;
          talkTalkActive?: boolean | null;
        };
  }>;
};

export type DeleteMyZzimsMutationVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type DeleteMyZzimsMutation = { __typename?: 'Mutation'; deleteMyZzims: boolean };

export type Pkgtour_Custom_Estimates_InitQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InputEstimateSortOptions>;
}>;

export type Pkgtour_Custom_Estimates_InitQuery = {
  __typename?: 'Query';
  ongoing: {
    __typename?: 'CustomEstimateGroupsResponse';
    totalCount: number;
    groupEstimates: Array<{
      __typename?: 'CustomEstimateGroupByStatus';
      estimateGroupId: string;
      groupType: { __typename?: 'CodeName'; code: string; name: string };
      personalCount?: {
        __typename?: 'PersonalCount';
        adult: number;
        infant?: number | null;
        child?: number | null;
      } | null;
      budget?: { __typename?: 'Budget'; amount: number; budgetType?: string | null; flexibility: string } | null;
      destinations?: Array<{
        __typename?: 'CodesOptionalName';
        codes?: Array<string> | null;
        name?: string | null;
      }> | null;
      estimates: Array<{
        __typename?: 'CustomEstimate';
        id: string;
        estimateRequestAgtCode: string;
        estimateId: string;
        estimateStatus: EstimateStatus;
        dayDiff?: number | null;
        createdAt: any;
        createdAtStr: string;
        activeReceivedAlert: boolean;
        customizeProduct?: {
          __typename?: 'CustomProduct';
          productId: string;
          beginDate: string;
          endDate?: string | null;
          productName: string;
          beginDateStr: string;
          endDateStr?: string | null;
          updatedAtStr: string;
          prices: { __typename?: 'ProductPrice'; adult: number; infant: number; child: number };
        } | null;
        customizeProductFamily?: {
          __typename?: 'CustomProductFamily';
          image?: string | null;
          dayPeriod: number;
          nightPeriod: number;
          airline?: { __typename?: 'CodeName'; name: string; code: string } | null;
        } | null;
        requestAgent: {
          __typename?: 'CustomAgent';
          name: string;
          agtCode: string;
          tel: string;
          landingUrl: string;
          agtLogoUrl: string;
        };
        customizeAgent?: { __typename?: 'CustomAgent'; landingUrl: string } | null;
      }>;
    }>;
  };
  confirmed: {
    __typename?: 'CustomEstimateGroupsResponse';
    totalCount: number;
    groupEstimates: Array<{
      __typename?: 'CustomEstimateGroupByStatus';
      estimateGroupId: string;
      groupType: { __typename?: 'CodeName'; code: string; name: string };
      personalCount?: {
        __typename?: 'PersonalCount';
        adult: number;
        infant?: number | null;
        child?: number | null;
      } | null;
      budget?: { __typename?: 'Budget'; amount: number; budgetType?: string | null; flexibility: string } | null;
      destinations?: Array<{
        __typename?: 'CodesOptionalName';
        codes?: Array<string> | null;
        name?: string | null;
      }> | null;
      estimates: Array<{
        __typename?: 'CustomEstimate';
        id: string;
        estimateRequestAgtCode: string;
        estimateId: string;
        estimateStatus: EstimateStatus;
        dayDiff?: number | null;
        createdAt: any;
        createdAtStr: string;
        activeReceivedAlert: boolean;
        customizeProduct?: {
          __typename?: 'CustomProduct';
          productId: string;
          beginDate: string;
          endDate?: string | null;
          productName: string;
          beginDateStr: string;
          endDateStr?: string | null;
          updatedAtStr: string;
          prices: { __typename?: 'ProductPrice'; adult: number; infant: number; child: number };
        } | null;
        customizeProductFamily?: {
          __typename?: 'CustomProductFamily';
          image?: string | null;
          dayPeriod: number;
          nightPeriod: number;
          airline?: { __typename?: 'CodeName'; name: string; code: string } | null;
        } | null;
        requestAgent: {
          __typename?: 'CustomAgent';
          name: string;
          agtCode: string;
          tel: string;
          landingUrl: string;
          agtLogoUrl: string;
        };
        customizeAgent?: { __typename?: 'CustomAgent'; landingUrl: string } | null;
      }>;
    }>;
  };
  canceled: {
    __typename?: 'CustomEstimateGroupsResponse';
    totalCount: number;
    groupEstimates: Array<{
      __typename?: 'CustomEstimateGroupByStatus';
      estimateGroupId: string;
      groupType: { __typename?: 'CodeName'; code: string; name: string };
      personalCount?: {
        __typename?: 'PersonalCount';
        adult: number;
        infant?: number | null;
        child?: number | null;
      } | null;
      budget?: { __typename?: 'Budget'; amount: number; budgetType?: string | null; flexibility: string } | null;
      destinations?: Array<{
        __typename?: 'CodesOptionalName';
        codes?: Array<string> | null;
        name?: string | null;
      }> | null;
      estimates: Array<{
        __typename?: 'CustomEstimate';
        id: string;
        estimateRequestAgtCode: string;
        estimateId: string;
        estimateStatus: EstimateStatus;
        dayDiff?: number | null;
        createdAt: any;
        createdAtStr: string;
        activeReceivedAlert: boolean;
        customizeProduct?: {
          __typename?: 'CustomProduct';
          productId: string;
          beginDate: string;
          endDate?: string | null;
          productName: string;
          beginDateStr: string;
          endDateStr?: string | null;
          updatedAtStr: string;
          prices: { __typename?: 'ProductPrice'; adult: number; infant: number; child: number };
        } | null;
        customizeProductFamily?: {
          __typename?: 'CustomProductFamily';
          image?: string | null;
          dayPeriod: number;
          nightPeriod: number;
          airline?: { __typename?: 'CodeName'; name: string; code: string } | null;
        } | null;
        requestAgent: {
          __typename?: 'CustomAgent';
          name: string;
          agtCode: string;
          tel: string;
          landingUrl: string;
          agtLogoUrl: string;
        };
        customizeAgent?: { __typename?: 'CustomAgent'; landingUrl: string } | null;
      }>;
    }>;
  };
  myInquiries: { __typename?: 'InquiryCount'; count: number; isNew: boolean };
};

export type GetMySearchHistoriesPageQueryVariables = Exact<{ [key: string]: never }>;

export type GetMySearchHistoriesPageQuery = {
  __typename?: 'Query';
  travelClubUser: { __typename?: 'TravelClubUser'; id: string; nickName: string; grade: number; gradeKo: string };
  me: { __typename?: 'Me'; id?: string | null; canUseCustomTravel: boolean; isLogin: boolean };
  mySearchHistories: Array<{
    __typename?: 'DisplayedSearchHistoryModelClass';
    snapshotPrice: number;
    timestamp: number;
    isDomestic: boolean;
    bookingUrl?: string | null;
    daysSinceLastViewed: number;
    timeString: string;
    product:
      | {
          __typename?: 'DomesticProductModelClass';
          productId: string;
          agtCode: string;
          productName: string;
          finalProductName: string;
          finalProductStatus: string;
          beginDate: string;
          endDate?: string | null;
          durationString: string;
          price: number;
          specialPrice: boolean;
          bookMinSeat: number;
          productFamily?: {
            __typename?: 'DomesticProductFamilyModelClass';
            departureCityName: string;
            nightPeriod: number;
            dayPeriod: number;
            firstImage: string;
            customRate?: boolean | null;
          } | null;
        }
      | {
          __typename?: 'OverseasProductMongooseClass';
          productId: string;
          agtCode: string;
          productName: string;
          finalProductName: string;
          productStatus: ProductStatus;
          beginTime?: string | null;
          beginDate: string;
          endDate?: string | null;
          updatedAt: any;
          emergency?: boolean | null;
          overseasBookMinSeat?: number | null;
          prices: { __typename?: 'ProductPrice'; adult: number };
          productFamily?: {
            __typename?: 'OverseasProductFamilyMongooseClass';
            nightPeriod: number;
            dayPeriod: number;
            firstImage: string;
            beginCityName?: string | null;
            customRate?: boolean | null;
            isTicketpassImmediately?: boolean | null;
            isTicketpass?: boolean | null;
            tips?: { __typename?: 'Tips'; include: boolean } | null;
            shopping?: { __typename?: 'Shopping'; count?: number | null } | null;
            ride?: { __typename?: 'Ride'; type: string; code: string; name: string; extra: string } | null;
            visitAreas: Array<{ __typename?: 'VisitAreaType'; cityName: string }>;
            tourCategory: { __typename?: 'TourCategory'; code: string };
          } | null;
        };
    agent:
      | {
          __typename?: 'DomesticAgentMongooseClass';
          landingUrl: string;
          talkTalkId?: string | null;
          talkTalkActive?: boolean | null;
        }
      | {
          __typename?: 'OverseasAgentMongooseClass';
          landingUrl: string;
          talkTalkId?: string | null;
          talkTalkActive?: boolean | null;
        };
  }>;
};

export type DeleteMySearchHistoriesMutationVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type DeleteMySearchHistoriesMutation = { __typename?: 'Mutation'; deleteMySearchHistories: boolean };

export type GetAvailableAgentsQueryVariables = Exact<{
  countryCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  excludeLandingUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetAvailableAgentsQuery = {
  __typename?: 'Query';
  customTravelOverseasAgentsByCountryCodes: Array<{
    __typename?: 'OverseasAgentMongooseClass';
    _id: string;
    agtCode: string;
    customActive?: boolean | null;
    customGroupTypes?: Array<GroupType> | null;
    agtLogoUrl: string;
    name: string;
  }>;
};

export type CreateCustomEstimatesMutationVariables = Exact<{
  estimateId: Scalars['String']['input'];
  estimateRequestAgtCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  contact: ContactWithoutHourRange;
  contactTradeId: Scalars['String']['input'];
  terms: Array<Term> | Term;
}>;

export type CreateCustomEstimatesMutation = {
  __typename?: 'Mutation';
  createCustomEstimatesByEstimateId: Array<{
    __typename?: 'CustomEstimate';
    id: string;
    estimateId: string;
    estimateStatus: EstimateStatus;
    estimateProductId: string;
    estimateProductFamilyId: string;
    estimateAgtCode: string;
    groupType: { __typename?: 'CodeName'; code: string; name: string };
    destinations?: Array<{
      __typename?: 'CodesOptionalName';
      codes?: Array<string> | null;
      name?: string | null;
    }> | null;
    tourSchedule?: {
      __typename?: 'TourSchedule';
      flexible: boolean;
      schedules: Array<{ __typename?: 'Schedule'; to: string; from: string }>;
    } | null;
    budget?: { __typename?: 'Budget'; budgetType?: string | null; amount: number; flexibility: string } | null;
    personalCount?: {
      __typename?: 'PersonalCount';
      adult: number;
      infant?: number | null;
      child?: number | null;
      flexible: boolean;
    } | null;
  }>;
};

export type SendSmsMutationVariables = Exact<{
  nationNo: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
}>;

export type SendSmsMutation = {
  __typename?: 'Mutation';
  sendSMS: { __typename?: 'SmsVerificationInfoGraphqlType'; tradeId: string };
};

export type VerifySmsMutationVariables = Exact<{
  tradeId: Scalars['String']['input'];
  smsVal: Scalars['String']['input'];
}>;

export type VerifySmsMutation = {
  __typename?: 'Mutation';
  verifySms: { __typename?: 'VerifySmsGraphqlType'; isValid: boolean };
};

export type CreateCustomEstimateMutationVariables = Exact<{
  estimateProductId: Scalars['String']['input'];
  estimateProductFamilyId: Scalars['String']['input'];
  estimateAgtCode: Scalars['String']['input'];
  estimateType: Scalars['String']['input'];
  requirements: Array<CodeNameInput> | CodeNameInput;
  groupType: CodeNameInput;
  contact: Contact;
  additionalRequirements?: InputMaybe<Scalars['String']['input']>;
  additionalRequirementCheckList?: InputMaybe<Array<CodeNameInput> | CodeNameInput>;
  destinations?: InputMaybe<Array<CodesNameInput> | CodesNameInput>;
  visitCountries?: InputMaybe<Array<CodeNameInput> | CodeNameInput>;
  tourSchedule?: InputMaybe<TourScheduleInput>;
  personalCount?: InputMaybe<PersonalCountInput>;
  specialNote?: InputMaybe<CodeNameInput>;
  budget?: InputMaybe<BudgetInput>;
  flight?: InputMaybe<FlightInput>;
  hotel?: InputMaybe<HotelInput>;
  mealOrShoppings?: InputMaybe<Array<CodeNameInput> | CodeNameInput>;
  contactTradeId: Scalars['String']['input'];
  terms: Array<Term> | Term;
}>;

export type CreateCustomEstimateMutation = {
  __typename?: 'Mutation';
  createCustomEstimate: {
    __typename?: 'CustomEstimate';
    id: string;
    estimateId: string;
    estimateStatus: EstimateStatus;
    estimateProductId: string;
    estimateProductFamilyId: string;
    estimateAgtCode: string;
    createdAt: any;
    groupType: { __typename?: 'CodeName'; code: string; name: string };
    destinations?: Array<{
      __typename?: 'CodesOptionalName';
      codes?: Array<string> | null;
      name?: string | null;
    }> | null;
    tourSchedule?: {
      __typename?: 'TourSchedule';
      flexible: boolean;
      schedules: Array<{ __typename?: 'Schedule'; to: string; from: string }>;
    } | null;
    budget?: { __typename?: 'Budget'; budgetType?: string | null; amount: number; flexibility: string } | null;
    personalCount?: {
      __typename?: 'PersonalCount';
      adult: number;
      infant?: number | null;
      child?: number | null;
      flexible: boolean;
    } | null;
  };
};

export type MyInquiriesQueryVariables = Exact<{ [key: string]: never }>;

export type MyInquiriesQuery = {
  __typename?: 'Query';
  myInquiries: { __typename?: 'InquiryCount'; count: number; isNew: boolean };
};
